import React from "react"
import { getAuth } from 'firebase/auth'; 
import { getFirestore } from "firebase/firestore"
import { LoadScript } from "@react-google-maps/api";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthProvider, FirestoreProvider, FunctionsProvider, useFirebaseApp } from "reactfire"

import { publicRotues, privateRoutes } from "./routes/index"
import { getFunctions } from "firebase/functions";

const router = createBrowserRouter([...publicRotues, ...privateRoutes]);

function App() {
  const app = useFirebaseApp();

  const auth = getAuth(app);
  const firestore = getFirestore(app);
  const functions = getFunctions()

  return (
    <AuthProvider sdk={auth}>
      <FirestoreProvider sdk={firestore}>
        <FunctionsProvider sdk={functions}>
          <LoadScript googleMapsApiKey="AIzaSyBJDhmBSXc38ILuQvjH0Z2M58yyJKk2pTk"/>
          <RouterProvider router={router} />
        </FunctionsProvider>
      </FirestoreProvider>
    </AuthProvider>
  );
}

export default App;
